// extracted by mini-css-extract-plugin
export default {"setting--inverted":"FGpSvC_","dark-theme":"Z6trBBU","swipeBar":"CNMKBuG"};